"use client";

import { useEffect } from "react";
import { ConsentStore } from "@/app/stores/ConsentStore";
import { ConsentChoice } from "@/app/types/consent/ConsentChoice";
import { URecaptcha } from "@/app/utils/URecaptcha";
import { Globals } from "@/app/vars/Globals";
import { Recaptcha as RecaptchaVars } from "@/app/vars/Recaptcha";

export default function RecaptchaPreload() {
  const choice = ConsentStore((state) => state.choice);

  useEffect(() => {
    if (!Globals.WAITLIST_ENABLED || choice !== ConsentChoice.ACCEPTED) {
      return;
    }

    if ("requestIdleCallback" in window) {
      const handle = window.requestIdleCallback(URecaptcha.preload, {
        timeout: RecaptchaVars.IDLE_PRELOAD_TIMEOUT_MS,
      });
      return () => window.cancelIdleCallback(handle);
    }

    const timeout = setTimeout(URecaptcha.preload, RecaptchaVars.IDLE_PRELOAD_TIMEOUT_MS);
    return () => clearTimeout(timeout);
  }, [choice]);

  return null;
}
